/*
 * Курс «Первая помощь» — доменный шаг `cpr`: тренажёр компрессий грудной клетки.
 *
 * Два входа, одна оценка (CprMeter, public/js/course/steps/cpr-meter.js):
 *   • «Телефон на подушке» — разрешение и доступ к датчику даёт MotionSensors
 *     (public/js/motion-sensors.js: iOS просит разрешение из нажатия), сэмплы —
 *     devicemotion, колебание ищет детектор шагомера;
 *   • «Нажатиями» — тап по большой кнопке или пробел.
 * Оценка — темп 100–120 в минуту и ровность (ERC 2021). Глубину телефон не
 * меряет, и шаг так и говорит.
 *
 * Данные шага (course.json): count (компрессий в цикле, 30), cycles (циклов),
 * breaths (пауза на 2 вдоха между циклами), metronome (метроном включён сразу),
 * who ('adult' | 'child' | 'infant' — только подсказка о руках).
 * Тексты интерфейса — `ui` в resources/lang/{locale}/tools/first-aid-course.php.
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K || !window.CprMeter) return;

    var METRO_BPM = 110;
    var GAUGE_MIN = 60, GAUGE_MAX = 160;

    function sensorPossible() {
        try {
            return ('DeviceMotionEvent' in window) && !!(window.MotionSensors && window.MotionSensors.isMobileLike && window.MotionSensors.isMobileLike());
        } catch (_) { return false; }
    }

    K.step('cpr', {
        graded: true,
        reviewable: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            var count = step.count || 30;
            var cycles = step.cycles || 1;
            var withBreaths = !!step.breaths;
            var who = step.who || 'adult';

            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host);

            var box = api.el('div', 'fa-cpr');
            host.appendChild(box);

            /* выбор входа */
            var modeRow = api.el('div', 'fa-modes');
            var mode = sensorPossible() ? 'phone' : 'tap';
            var modeBtns = {};
            [['phone', api.tt('cpr_mode_phone')], ['tap', api.tt('cpr_mode_tap')]].forEach(function (m) {
                if (m[0] === 'phone' && !sensorPossible()) return;
                var b = api.el('button', 'crs-chip', m[1]);
                b.type = 'button';
                b.setAttribute('aria-pressed', m[0] === mode ? 'true' : 'false');
                b.addEventListener('click', function () { setMode(m[0]); });
                modeBtns[m[0]] = b;
                modeRow.appendChild(b);
            });
            if (Object.keys(modeBtns).length > 1) box.appendChild(modeRow);
            var how = api.el('p', 'crs-hint');
            box.appendChild(how);
            var whoTx = who === 'infant' ? api.tt('cpr_who_infant') : who === 'child' ? api.tt('cpr_who_child') : api.tt('cpr_who_adult');
            box.appendChild(api.el('p', 'crs-hint', whoTx));

            var metroLbl = api.el('label', 'fa-metro');
            var metroCb = api.el('input');
            metroCb.type = 'checkbox';
            metroCb.checked = step.metronome !== false;
            metroLbl.appendChild(metroCb);
            metroLbl.appendChild(document.createTextNode(' ' + api.tt('cpr_metronome', { bpm: METRO_BPM })));
            box.appendChild(metroLbl);

            /* живой экран */
            var live = api.el('div', 'fa-live');
            live.hidden = true;
            var cycleTx = api.el('div', 'fa-cycle');
            var big = api.el('div', 'fa-count', '0');
            var of = api.el('div', 'fa-of');
            var gauge = api.el('div', 'fa-gauge');
            var zone = api.el('span', 'fa-zone');
            zone.style.left = pos(100) + '%';
            zone.style.width = (pos(120) - pos(100)) + '%';
            var needle = api.el('span', 'fa-needle');
            needle.style.left = pos(GAUGE_MIN) + '%';
            gauge.appendChild(zone);
            gauge.appendChild(needle);
            var scale = api.el('div', 'fa-scale');
            [60, 100, 120, 160].forEach(function (v) {
                var s = api.el('span', null, String(v));
                s.style.left = pos(v) + '%';
                scale.appendChild(s);
            });
            var rateTx = api.el('div', 'fa-rate', api.tt('cpr_rate_wait'));
            var cue = api.el('div', 'fa-cue');
            cue.setAttribute('aria-live', 'polite');
            var press = api.el('button', 'fa-press', api.tt('cpr_press'));
            press.type = 'button';
            press.hidden = true;
            var breathBox = api.el('div', 'fa-breaths');
            breathBox.hidden = true;
            live.appendChild(cycleTx);
            live.appendChild(big);
            live.appendChild(of);
            live.appendChild(gauge);
            live.appendChild(scale);
            live.appendChild(rateTx);
            live.appendChild(cue);
            live.appendChild(press);
            live.appendChild(breathBox);
            box.appendChild(live);
            box.appendChild(api.el('p', 'crs-hint fa-honest', api.tt('cpr_honest')));

            function pos(v) { return Math.max(0, Math.min(100, (v - GAUGE_MIN) / (GAUGE_MAX - GAUGE_MIN) * 100)); }

            function setMode(m) {
                mode = m;
                for (var k in modeBtns) modeBtns[k].setAttribute('aria-pressed', k === m ? 'true' : 'false');
                how.textContent = m === 'phone' ? api.tt('cpr_phone_how') : api.tt('cpr_tap_how');
            }
            setMode(mode);

            /* состояние прогона */
            var meter = null, all = [], cycle = 0, inCycle = 0, phase = 'idle';
            var ms = null, motionFn = null, keyFn = null, metro = null, sensorTimer = null, idleTimer = null;
            var breathPauses = [], breathStart = 0, lastAt = 0;

            api.onCleanup(stopAll);

            function stopAll() {
                if (ms) { try { ms.stop(); } catch (_) {} ms = null; }
                if (motionFn) { window.removeEventListener('devicemotion', motionFn); motionFn = null; }
                if (keyFn) { document.removeEventListener('keydown', keyFn, true); keyFn = null; }
                if (metro) { metro.stop(); metro = null; }
                if (sensorTimer) { clearTimeout(sensorTimer); sensorTimer = null; }
                if (idleTimer) { clearInterval(idleTimer); idleTimer = null; }
            }

            function onCompression(c) {
                if (phase !== 'pressing') return;
                lastAt = Date.now();
                inCycle++;
                all.push(c.rate);
                big.textContent = String(inCycle);
                if (c.rate > 0) {
                    needle.style.left = pos(c.rate) + '%';
                    rateTx.textContent = api.tt('cpr_rate', { rate: Math.round(c.rate) });
                    var cl = c.rate < 100 ? 'slow' : c.rate > 120 ? 'fast' : 'ok';
                    cue.className = 'fa-cue is-' + cl;
                    cue.textContent = cl === 'slow' ? api.tt('cpr_slow') : cl === 'fast' ? api.tt('cpr_fast') : api.tt('cpr_ok');
                }
                if (inCycle >= count) endCycle();
            }

            function newMeter() {
                meter = window.CprMeter.create({ onCompression: onCompression });
            }

            function startMetro() {
                if (!metroCb.checked || metro) return;
                var stop = false, nextT = 0, timer = null;
                api.audioCtx().then(function (ctx) {
                    if (stop) return;
                    nextT = ctx.currentTime + 0.1;
                    timer = setInterval(function () {
                        if (stop) return;
                        while (nextT < ctx.currentTime + 0.25) {
                            var o = ctx.createOscillator(), g = ctx.createGain();
                            o.frequency.value = 1400;
                            g.gain.setValueAtTime(0.0001, nextT);
                            g.gain.exponentialRampToValueAtTime(0.35, nextT + 0.002);
                            g.gain.exponentialRampToValueAtTime(0.0001, nextT + 0.05);
                            o.connect(g); g.connect(ctx.destination);
                            o.start(nextT); o.stop(nextT + 0.06);
                            nextT += 60 / METRO_BPM;
                        }
                    }, 60);
                }).catch(function () {});
                metro = { stop: function () { stop = true; if (timer) clearInterval(timer); } };
            }
            function stopMetro() { if (metro) { metro.stop(); metro = null; } }

            function startCycle() {
                cycle++;
                inCycle = 0;
                phase = 'pressing';
                lastAt = Date.now();
                big.textContent = '0';
                of.textContent = api.tt('cpr_of', { total: count });
                cycleTx.textContent = cycles > 1 ? api.tt('cpr_cycle', { n: cycle, total: cycles }) : '';
                rateTx.textContent = api.tt('cpr_rate_wait');
                cue.className = 'fa-cue';
                cue.textContent = '';
                needle.style.left = pos(GAUGE_MIN) + '%';
                breathBox.hidden = true;
                breathBox.innerHTML = '';
                newMeter();
                startMetro();
                if (mode === 'tap') {
                    press.hidden = false;
                    try { press.focus({ preventScroll: true }); } catch (_) {}
                }
            }

            function endCycle() {
                phase = 'between';
                stopMetro();
                cycleStats.push(meter.stats());
                if (withBreaths && cycle < cycles) { breaths(); return; }
                finish();
            }

            var cycleStats = [];

            function breaths() {
                press.hidden = true;
                breathStart = Date.now();
                breathBox.hidden = false;
                breathBox.innerHTML = '';
                breathBox.appendChild(api.el('p', 'crs-prompt', api.tt('cpr_breaths')));
                var row = api.el('div', 'crs-self');
                var done = 0;
                [1, 2].forEach(function (n) {
                    var b = api.el('button', 'lg-btn lg-btn-ghost', api.tt('cpr_breath_btn', { n: n }));
                    b.type = 'button';
                    b.addEventListener('click', function () {
                        if (b.disabled) return;
                        b.disabled = true;
                        done++;
                        if (done === 2) {
                            breathPauses.push((Date.now() - breathStart) / 1000);
                            startCycle();
                        }
                    });
                    row.appendChild(b);
                });
                breathBox.appendChild(row);
            }

            function finish() {
                phase = 'done';
                stopAll();
                press.hidden = true;
                var times = [];
                // общий итог — по всем циклам: доля компрессий в зоне взвешена числом
                var n = 0, zoneSum = 0, slowSum = 0, fastSum = 0, rateSum = 0, cvMax = 0, rated = 0;
                cycleStats.forEach(function (s) {
                    n += s.n;
                    var r = Math.max(0, s.n - 2);
                    rated += r;
                    zoneSum += s.zone * r; slowSum += s.slow * r; fastSum += s.fast * r;
                    rateSum += s.rate * s.n;
                    cvMax = Math.max(cvMax, s.cv);
                });
                var S = {
                    n: n,
                    rate: n ? rateSum / n : 0,
                    zone: rated ? zoneSum / rated : 0,
                    slow: rated ? slowSum / rated : 0,
                    fast: rated ? fastSum / rated : 0,
                    cv: cvMax
                };
                var v = window.CprMeter.verdict(S);
                var lines = [api.tt('cpr_res_' + v.key)];
                if (S.n >= 3) lines.push(api.tt('cpr_stats', { rate: Math.round(S.rate), zone: Math.round(S.zone * 100) }));
                var longPause = breathPauses.filter(function (p) { return p > 10; });
                if (longPause.length) lines.push(api.tt('cpr_pause_long', { s: Math.round(Math.max.apply(null, longPause)) }));
                if (t.explain) lines.push(t.explain);
                api.answer({ correct: v.ok, score: v.score, explain: lines.join('\n\n') });
            }

            function startSensor() {
                ms = new window.MotionSensors();
                var got = 0;
                motionFn = function (e) {
                    var a = e.accelerationIncludingGravity;
                    if (!a || typeof a.x !== 'number') return;
                    got++;
                    if (phase !== 'pressing' || !meter) return;
                    meter.motion(e.timeStamp || performance.now(), a.x, a.y, a.z);
                    if (!meter.flat()) {
                        cue.className = 'fa-cue is-slow';
                        cue.textContent = api.tt('cpr_not_flat');
                    }
                };
                return ms.enable().then(function (res) {
                    if (!api.alive()) return false;
                    if (res.permission !== 'granted') {
                        fallback(api.tt('cpr_sensor_denied'));
                        return false;
                    }
                    window.addEventListener('devicemotion', motionFn, { passive: true });
                    sensorTimer = setTimeout(function () {
                        if (!got && api.alive()) fallback(api.tt('cpr_no_sensor'));
                    }, 2500);
                    return true;
                }, function () {
                    fallback(api.tt('cpr_no_sensor'));
                    return false;
                });
            }

            function fallback(msg) {
                if (motionFn) { window.removeEventListener('devicemotion', motionFn); motionFn = null; }
                if (ms) { try { ms.stop(); } catch (_) {} ms = null; }
                setMode('tap');
                cue.className = 'fa-cue is-slow';
                cue.textContent = msg;
                api.announce(msg);
                press.hidden = phase !== 'pressing';
                bindTap();
            }

            function bindTap() {
                if (keyFn) return;
                keyFn = function (e) {
                    if (phase !== 'pressing' || mode !== 'tap') return;
                    if (e.code !== 'Space' && e.key !== ' ') return;
                    // Пробел на самой кнопке «Нажимать» — компрессия; в чужом поле — его клавиша.
                    if (document.activeElement !== press) {
                        var owned = false;
                        try { owned = window.__keyOwnedByFocus ? window.__keyOwnedByFocus(e) : false; } catch (_) {}
                        if (owned) return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.repeat) return;
                    if (meter) meter.tap(performance.now());
                };
                document.addEventListener('keydown', keyFn, true);
            }

            press.addEventListener('pointerdown', function (e) {
                if (phase !== 'pressing' || mode !== 'tap' || !meter) return;
                e.preventDefault();
                meter.tap(e.timeStamp || performance.now());
                press.classList.remove('is-hit');
                void press.offsetWidth;
                press.classList.add('is-hit');
            });

            function start() {
                api.primary(null, null);
                api.secondary(api.tt('cpr_stop'), function () {
                    if (meter && meter.count()) cycleStats.push(meter.stats());
                    finish();
                });
                if (modeRow.parentNode) modeRow.hidden = true;
                live.hidden = false;
                bindTap();
                var go = function () { if (api.alive()) startCycle(); };
                if (mode === 'phone') startSensor().then(go);
                else go();
                // тишина дольше 6 с посреди цикла — подсказка продолжать
                idleTimer = setInterval(function () {
                    if (phase === 'pressing' && Date.now() - lastAt > 6000) {
                        cue.className = 'fa-cue is-slow';
                        cue.textContent = api.tt('cpr_keep_going');
                    }
                }, 1000);
            }

            api.primary(api.tt('cpr_start'), start);
            api.secondary(api.t('skip'), function () { api.skip(); });
        }
    });
})();
